import { render, staticRenderFns } from "./FinancialService.vue?vue&type=template&id=65e4b1c8&scoped=true"
import script from "./FinancialService.vue?vue&type=script&lang=js"
export * from "./FinancialService.vue?vue&type=script&lang=js"
import style0 from "./FinancialService.vue?vue&type=style&index=0&id=65e4b1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4b1c8",
  null
  
)

export default component.exports